import { VxModelsLogo } from '@campoint/odi-ui-icons';
import { Box, Button, Icon, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type SwitchVXMClassicProps = {
  onClick: () => void;
};

export const SwitchVXMClassic: React.FC<SwitchVXMClassicProps> = ({
  onClick,
}) => {
  const { t } = useTranslation(['home']);
  return (
    <Box
      p={4}
      bg={'white'}
      width={'100%'}
      display={'flex'}
      flexDirection={'row'}
      flexWrap={'wrap'}
      justifyContent={'flex-start'}
      alignItems={'center'}
      gap={4}
    >
      <Icon as={VxModelsLogo} boxSize="icon.lg" color="vxModels.500" />
      <Text mb={0}>{t('home:switch.banner')}</Text>
      <Button
        variant={'outline'}
        children={t('home:switch.modalLink')}
        onClick={onClick}
      />
    </Box>
  );
};
